import { ErrorHandler, Provider } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';

import { GlobalErrorStateMatcher } from '@shared/material/error/error-state-matcher';
import { AppInitializerService } from '@shared/services/app-initializer.service';
import { ApplicationInsightsService } from '@shared/services/application-insights.service';
import { ClarityService } from '@shared/services/clarity.service';
import { GlobalErrorHandlerService } from '@shared/services/global-error-handler.service';
import { OrderingService } from '@shared/services/ordering.service';
import { SeoService } from '@shared/services/seo.service';
import { ToastNotificationsService } from '@shared/services/toast-notifications.service';

export const APP_PROVIDERS: Provider[] = [
  { provide: ErrorStateMatcher, useClass: GlobalErrorStateMatcher },
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandlerService
  },
  AppInitializerService,
  ApplicationInsightsService,
  ClarityService,
  OrderingService,
  SeoService,
  ToastNotificationsService
];
